"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_list_store_1 = require("owa-mail-list-store");
var owa_mail_store_1 = require("owa-mail-store");
/**
 * Create the item contexts for triage actions that need delete store update
 * @param itemIds of the items that need to be updated in store
 * @returns the item contexts to be used to update the store
 */
function createItemContextsForDeleteStoreUpdate(itemIds) {
    var itemContexts = itemIds.map(function (itemIdValue) {
        var item = owa_mail_store_1.mailStore.items.get(itemIdValue);
        var isReadValue;
        if (owa_mail_list_store_1.isItemOfMessageType(item)) {
            isReadValue = item.IsRead;
        }
        else {
            // Default to isRead = true when not a mail item
            isReadValue = true;
        }
        return {
            itemId: itemIdValue,
            conversationId: item.ConversationId.Id,
            isRead: isReadValue,
        };
    });
    return itemContexts;
}
exports.default = createItemContextsForDeleteStoreUpdate;
//# sourceMappingURL=createItemContextsForDeleteStoreUpdate.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/helpers/createItemContextsForDeleteStoreUpdate.js
// module id = 3114
// module chunks = 62